import React from 'react'
import TableContainer from '@material-ui/core/TableContainer'
import MuiTable from '@material-ui/core/Table'
import TableHead from './TableHead'
import TableBody from './TableBody'

export interface Column<T> {
  id: keyof T | string
  label: string
  path?: keyof T
  content?: (item: T, index: number) => any
  width?: number
  style?: (item: T) => React.CSSProperties | undefined
}

interface Props<T> {
  data: T[]
  columns: Column<T>[]
  onRowClick?: (e: React.MouseEvent<HTMLTableRowElement>, item: T) => void
  className?: string | undefined
}
const Table = <T,>({ columns, data, onRowClick, className }: Props<T>) => {
  return (
    <TableContainer className={className}>
      <MuiTable size="small">
        <TableHead columns={columns} />
        <TableBody
          columns={columns}
          data={data}
          onRowClick={onRowClick}
          // page={page}
          // rowsPerPage={rowsPerPage}
        />
      </MuiTable>
    </TableContainer>
  )
}

export default Table
